<template>
  <el-dialog
    :title="analyzeName+'重跑分析'"
    :visible.sync="dialogVisible"
    destroy-on-close :before-close="cancel">
    <el-form label-width="100px">
      <el-form-item label="已选择的分组" v-if="!nonGroup" >
        <div :style="groupSample.length>8?'height:340px;overflow-y: auto':''" >
          <el-checkbox-group v-model="group">
            <el-checkbox border :label="item.groupName" v-for="(item,index) in groupSample" class="checkbox-setting"
                         :key="index" style="width: 100%;overflow-x: hidden" disabled>
              <div style="display: flex;margin-bottom: 2px;justify-items: center">
                <div>{{ item.groupName }}</div>
                <el-tooltip :content="item.sampleName.join(',')" :disabled="item.sampleName.length<=4">
                            <span style="margin-left:20px">{{'(共包含' + item.sampleName.length + '个样本)\t' + showGroupExceed(item.sampleName)}}
                              <span v-if="item.sampleName.length>=4">...</span>
                            </span>
                </el-tooltip>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>

      </el-form-item>
      <el-form-item :label="nonGroup?'颜色':'分组颜色'">
        <div :style="groupColor.length>6?'height:340px;overflow-y: auto':';'">
          <div style="display:flex;margin-bottom: 10px;" v-for="(item, index) in groupColor" :key="item.groupName"
               draggable="true"
               @dragstart="handleDragStart($event, item)"
               @dragover.prevent="handleDragOver($event, item)"
               @dragenter="handleDragEnter($event, item)"
               @dragend="handleDragEnd($event, item)">
            <span :style="'flex:none;;white-space:nowrap;width:'+groupNameMaxLength">{{ item.groupName }}</span>
            <el-input v-model="item.color" style="min-width:100px;margin-left: 20px"></el-input>
            <div style="text-align:center;display:flex">
              <el-color-picker v-model="item.color" :predefine="predefineColors" style="margin-left:20px"
              ></el-color-picker>
              <div v-if="errColor[index]=((!item.color)||(item.color)&&checkIsColor(item.color))"
                   class="errMess" style="text-align:center ;color: #f36f70">颜色格式错误或者为空
              </div>
              <el-tooltip content="上移">
                <el-button :disabled="index===0" size="mini" class="move-up-button" @click="handleMoveUp(item)"><i class="el-icon-top"></i></el-button>
              </el-tooltip>
              <el-tooltip content="下移">
                <el-button :disabled="index===groupColor.length-1" size="mini" class="move-up-button" @click="handleMoveDown(item)"><i class="el-icon-bottom"></i></el-button>
              </el-tooltip>
            </div>
          </div>
        </div>
<!--        <span style="color: #b2b2b2">注：组名的顺序也可通过上下拖动{{nonGroup?'':'分组'}}颜色中的组名，从而达到顺序的改变</span>-->
        <span style="color: #b2b2b2">注：可拖动上方{{nonGroup?'':'分组'}}颜色中的{{nonGroup?'样本名':'组名'}}进行排序，从而调整{{nonGroup?'样本名':'组名'}}在分析中图例的顺序</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
    <el-button @click="cancel">取 消</el-button>
    <el-button type="primary" @click="confirm">重 跑</el-button>
  </span>
  </el-dialog>
</template>

<script>
import {defaultColor} from '@/utils/PublicConstant'
import {checkIsColor} from "@/utils/utils";

export default {
  name: "ReRunAnalyze",
  props: ['groupSampleData', 'analyzeId'],
  data() {
    return {
      dialogVisible: true,
      groupSample:[],
      nonGroup:true,
      groupNameMaxLength: '80px',
      analyzeName: '',
      errColor: [],
      colorContainer:'',
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577',
        '#d87c7c',
        '#919e8b',
        '#d7ab82',
        '#6e7074',
        '#111111',
        '#ffffff',
      ],
      defaultColor: defaultColor,
      group: [],
      groupColor: [],
      ending: null,
      dragging: null,
    };
  },
  created() {
    this.getGroup()
    this.getGroupColor()
  },
  methods: {
    getGroup() {
      let group = []
      this.nonGroup=this.groupSampleData.nonGroup
      this.groupSample=this.groupSampleData.groupSample
      this.groupSample.map(item => {
        group.push(item.groupName)
      })
      this.group = group
    },
    getGroupColor() {
      let groupColor = []
      let sampleNameLength = []
      this.group.map((value, index) => {
        groupColor.push({
          groupName: value,
          color: this.defaultColor[index]
        })
        sampleNameLength.push(value.length)
        let isAddRoll=groupColor.length>6?'height:300px;overflow-y: auto':';'
        this.colorContainer='display:flex;margin-bottom: 10px;'+isAddRoll
      })
      const sampleNameLengthMax = Math.max(...sampleNameLength)
      this.groupNameMaxLength = sampleNameLengthMax * 8 + 'px'
      this.groupColor = groupColor
    },
    showGroupExceed(sampleNames) {
      if (sampleNames.length >= 4) {
        return sampleNames.slice(0, 4).join(',')
      } else {
        return sampleNames.join(',')
      }
    },
    confirm() {

      this.$emit('submitData', this.groupColor, this.analyzeId, 'confirm')
    },
    cancel() {
      this.$emit('submitData', this.groupColor, this.analyzeId, 'cancel')
    },
    checkIsColor(color) {
      return checkIsColor(color)
    },
    handleDragStart(e, item) {
      this.dragging = item
    },
    handleDragEnd(e, item) {
      if (this.ending.groupName === this.dragging.groupName) {
        return;
      }
      let newItems = [...this.groupColor]
      const src = newItems.indexOf(this.dragging)
      const dst = newItems.indexOf(this.ending)
      newItems.splice(src, 1, ...newItems.splice(dst, 1, newItems[src]))
      console.log(newItems)

      this.groupColor = newItems
      this.$nextTick(() => {
        this.dragging = null
        this.ending = null
      });
    },
    handleDragOver(e) {
      // 首先把div变成可以放置的元素，即重写dragenter/dragover
      // 在dragenter中针对放置目标来设置
      e.dataTransfer.dropEffect = "move"
    },
    handleDragEnter(e, item) {
      // 为需要移动的元素设置dragstart事件
      e.dataTransfer.effectAllowed = "move"
      this.ending = item
    },
    handleMoveUp(item){
      let newItems = [...this.groupColor]
      let index=newItems.indexOf(item)
      newItems.splice(index,1,...newItems.splice(index-1,1,item))
      this.groupColor=newItems
    },
    handleMoveDown(item){
      let newItems = [...this.groupColor]
      let index=newItems.indexOf(item)
      newItems.splice(index,1,...newItems.splice(index+1,1,item))
      this.groupColor=newItems
    },
  }
}
</script>

<style scoped>
.checkbox-setting {
  width: 100%;
  padding: 0 3px !important;
  margin: 8px 0 !important;
  display: flex;
  align-items: center;


}

.errMess {
  color: #933535;
  margin-left: 10px;
  font-size: 15px;
  width: 160px;
  font-family: "Microsoft YaHei";
}

/deep/ .el-dialog {
  min-width: 500px !important; /* 设置固定宽度 */
  width: 40%;
}
.move-up-button{
  padding:10px;
  height: 40px;
  margin-left: 10px
}
</style>
